import type { ReactElement } from "react"
import CategoryCardMol from "@onestore/hel/dist/components/molecules/CategoryCardMol"
import PromoInfo from "@onestore/hel/dist/components/molecules/CategoryCardMol/PromoInfo"
import PromoPrefix from "@onestore/hel/dist/components/molecules/CategoryCardMol/PromoPrefix"
import Title from "@onestore/hel/dist/components/molecules/CategoryCardMol/Title"
import PortalContainerOrg, {
  PortalType,
} from "@onestore/hel/dist/components/organisms/PortalContainerOrg"
import BaseMarkdown from "@gatsby-plugin-generic-page/components/Markdown/Base"
import type { CategoryCardData } from "@gatsby-plugin-generic-page/fragments/categoryCard"
import useSectionsModal from "@gatsby-plugin-generic-page/hooks/useSectionsModal"
import Media from "../Media"
import SideModal from "../SideModal"

type Props = {
  card: CategoryCardData
  sectionBackgroundColor: string
}

function CategoryCard({
  card,
  sectionBackgroundColor,
}: Props): ReactElement<Props> {
  const { title, caption, text, responsiveImages, backgroundColor, sideModal } =
    card
  const { isOpen, handleOpenOverlay, handleCloseOverlay } = useSectionsModal()

  return (
    <>
      <CategoryCardMol
        image={<Media media={responsiveImages} />}
        backTileColor={backgroundColor.color}
        title={
          <Title>
            <BaseMarkdown>{title}</BaseMarkdown>
          </Title>
        }
        promoPrefix={<PromoPrefix>{caption}</PromoPrefix>}
        promoInfo={<PromoInfo>{text}</PromoInfo>}
        onClick={(event) => handleOpenOverlay(event, title)}
        backgroundColor={sectionBackgroundColor}
        hasImageStuckToRight
      />

      <PortalContainerOrg portalType={PortalType.MODAL}>
        <SideModal
          isOpen={isOpen}
          onCloseButtonClick={handleCloseOverlay}
          categoryName={title}
          {...sideModal[0].flatData}
        />
      </PortalContainerOrg>
    </>
  )
}

export default CategoryCard
